import { render, staticRenderFns } from "./PwSearchResult.vue?vue&type=template&id=2c899047&scoped=true&"
import script from "./PwSearchResult.vue?vue&type=script&lang=js&"
export * from "./PwSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c899047",
  null
  
)

export default component.exports